<template>
    <v-footer absolute class="font-weight-medium " dark app>
      <v-col class="text-center" cols="12">
        <p class="copyright">
          <strong>&copy; Copyright {{ new Date().getFullYear() }} ISLAND STATE MUSIC</strong>
        </p>
      </v-col>
    </v-footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped>

p.copyright {
  width: 100%;
  font-size: 0.7em;
  text-align: center;
  letter-spacing: 1px;
  max-width: 860px;
  margin: auto;
}
</style>